import { Component, OnInit } from '@angular/core';
import {
    AbstractControl,
    UntypedFormControl,
    UntypedFormGroup,
    ValidatorFn,
    Validators
} from '@angular/forms';
import { LoggingService } from '../../shared/services/logging/logging.service';
import {
    DynamicDialogConfig,
    DynamicDialogRef
} from '../../shared/efaact-primeng.module';

@Component({
    selector: 'ef-reconciliation-memorize-template-popup',
    templateUrl: './reconciliation-memorize-template-popup.component.html',
    styleUrls: ['./reconciliation-memorize-template-popup.component.scss'],
    standalone: false
})
export class ReconciliationMemorizeTemplatePopupComponent implements OnInit {
    form: UntypedFormGroup;
    constructor(
        public dialogRef: DynamicDialogRef,
        private log: LoggingService,
        private config: DynamicDialogConfig
    ) {
        this.log.verbose({
            type: 'ReconciliationMemorizeTemplatePopupComponent::',
            config
        });
        this.form = new UntypedFormGroup({
            TemplateName: new UntypedFormControl(null, [
                Validators.required,
                this.forbiddenNameValidator(config.data.names)
            ])
        });
    }
    ngOnInit(): void {}
    forbiddenNameValidator(names: string[]): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const forbidden = names.findIndex(x => x === control.value) >= 0;
            return forbidden
                ? { forbiddenName: { value: `${control.value} is already in use.` } }
                : null;
        };
    }
}
